import clsx from "clsx";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useLanguage } from "units/dashboard/context/LanguageProvider";
import { RTL_LANGUAGES } from "i18n";

export default function BillingToggle({ yearly, onChange }) {
  const { t } = useTranslation("landing");
  const { lang } = useLanguage();
  const isRTL = RTL_LANGUAGES.includes(lang);

  return (
    <div className="mb-10 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
      <button
        type="button"
        onClick={() => onChange(false)}
        className={clsx(
          "text-[14px] font-semibold transition-colors",
          !yearly ? "text-ink" : "text-ink-mute hover:text-ink-soft"
        )}
      >
        {t("pricing.monthly")}
      </button>

      <button
        type="button"
        role="switch"
        aria-checked={yearly}
        aria-label="Toggle yearly billing"
        onClick={() => onChange(!yearly)}
        className={clsx(
          "relative h-8 w-[60px] shrink-0 rounded-full border-[1.5px] border-line bg-surface-2",
          "transition-colors hover:border-teal-2",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-2 focus-visible:ring-offset-2"
        )}
      >
        <motion.span
          layout
          transition={{ type: "spring", stiffness: 500, damping: 32 }}
          className={clsx(
            "absolute top-[3px] h-[22px] w-[22px] rounded-full bg-gradient-to-br from-teal to-teal-2 shadow-[0_3px_8px_rgba(0,0,0,0.2)]",
            yearly
              ? isRTL
                ? "right-[31px]"
                : "left-[31px]"
              : isRTL
              ? "right-[3px]"
              : "left-[3px]"
          )}
        />
      </button>

      <button
        type="button"
        onClick={() => onChange(true)}
        className={clsx(
          "text-[14px] font-semibold transition-colors",
          yearly ? "text-ink" : "text-ink-mute hover:text-ink-soft"
        )}
      >
        {t("pricing.yearly")}
      </button>

      <span className="rounded-full bg-gradient-to-br from-gold to-gold-2 px-3 py-1 text-[11px] font-extrabold text-amber-950 shadow-[0_4px_12px_rgba(201,162,39,0.3)]">
        {t("pricing.save")}
      </span>
    </div>
  );
}